import React from 'react'

import './loaderDotsStyle.css'

const LoaderDots = () => {
    return (
        <div className="loader-dots">
            <div className="dot move-first-dot"></div>
            <div className="dot move-second-dot"></div>
            <div className="dot move-third-dot"></div>
            <div className="dot move-fourth-dot"></div>
            <div className="dot move-fith-dot"></div>
            <div className="dot move-sixth-dot"></div>
            <div className="dot move-seventh-dot"></div>
            <div className="dot move-eigth-dot"></div>
            <div className="dot move-nineth-dot"></div>
            <div className="dot move-tenth-dot"></div>
        </div>
    )
}
export default LoaderDots